import * as tslib_1 from "tslib";
import { environment } from 'environments/environment';
import { ApiHelper } from '../helpers/home-api.helper';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { saveAs } from 'file-saver';
import { PolicyService } from './policy.service';
var DownloadService = /** @class */ (function () {
    function DownloadService(apiHelper, http, policyService) {
        this.apiHelper = apiHelper;
        this.http = http;
        this.policyService = policyService;
    }
    DownloadService.prototype.download = function (url, fileName, type, overrideHeaders) {
        var _this = this;
        if (url === void 0) { url = ''; }
        if (fileName === void 0) { fileName = 'doc.pdf'; }
        if (type === void 0) { type = 'application/pdf'; }
        if (overrideHeaders === void 0) { overrideHeaders = {}; }
        return new Observable(function (observer) {
            var defaultHeaders = {
                'Content-Type': 'application/stream',
                'x-authorization': localStorage.getItem('tk'),
                'x-branchOffice': localStorage.getItem('branchOffice')
            };
            var requestHeaders = tslib_1.__assign({}, defaultHeaders, overrideHeaders);
            _this.apiHelper.getWithoutResponse(url, null, requestHeaders, 'blob')
                .subscribe(function (file) {
                var headers = new HttpHeaders();
                var headerFileName = headers['x-filename'];
                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([file], { type: type });
                    var urlLink = window.URL.createObjectURL(blob);
                    linkElement.setAttribute('href', urlLink);
                    linkElement.setAttribute('download', headerFileName || fileName);
                    var clickEvent = new MouseEvent('click', {
                        'view': window,
                        'bubbles': true,
                        'cancelable': false
                    });
                    linkElement.dispatchEvent(clickEvent);
                }
                catch (ex) {
                    observer.error(ex);
                    observer.complete();
                }
                observer.next(true);
                observer.complete();
            }, function (error) {
                observer.error(error);
                observer.complete();
            });
        });
    };
    DownloadService.prototype.downloadPdf = function (url, fileName, request) {
        if (url === void 0) { url = ""; }
        if (fileName === void 0) { fileName = 'doc.pdf'; }
        if (request === void 0) { request = {}; }
        return this.http.post(url, request, { responseType: 'blob' })
            .pipe(map(function (response) {
            saveAs(response, fileName);
        }));
    };
    DownloadService.prototype.downloadAutoPolicyChange = function (jobNumber) {
        var endpoint = environment.server.api.car + "/api/Reports/policyChange?JobNumber=" + jobNumber;
        return this.download(endpoint, "Endoso_" + jobNumber, 'application/pdf');
    };
    DownloadService.prototype.downloadContractorsAttachment = function (jobNumber) {
        var endpoint = environment.server.api.car + "/api/Reports/contractorsAttachment?JobNumber=" + jobNumber;
        return this.download(endpoint, "Endoso_" + jobNumber + "_AnexoContratistas", 'application/pdf');
    };
    DownloadService.prototype.downloadAdditionalInsured = function (jobNumber, inciso) {
        if (inciso === void 0) { inciso = '1'; }
        var endpoint = environment.server.api.portalpasProxy + "/reports-integration/api/AdditionalInsured";
        var fileName = "Coparticipante_Contratista_" + jobNumber + ".pdf";
        var request = {
            clauses: 0,
            inciso: inciso,
            endorsement: this.policyService.getEndorsementByJobNumber(jobNumber),
            policyNumberBranchOffice: this.policyService.getPolicyNumberByJobNumber(jobNumber)
        };
        return this.downloadPdf(endpoint, fileName, request);
    };
    DownloadService.prototype.downloadEndorsement = function (jobNumber, inciso) {
        if (inciso === void 0) { inciso = '1'; }
        var endpoint = environment.server.api.portalpasProxy + "/reports-integration/api/Endorsement";
        var fileName = jobNumber + ".pdf";
        var request = {
            clauses: 0,
            inciso: inciso,
            endorsement: this.policyService.getEndorsementByJobNumber(jobNumber),
            policyNumberBranchOffice: this.policyService.getPolicyNumberByJobNumber(jobNumber)
        };
        return this.downloadPdf(endpoint, fileName, request);
    };
    return DownloadService;
}());
export { DownloadService };
